/* eslint-disable import/no-anonymous-default-export */
const initialState = {
  x: 400,
  pipes: [],
};

const determineMaximumDifference = (pipes) => {
  if (pipes.length > 45) {
    return 400;
  }
  if (pipes.length > 32) {
    return 350;
  }
  if (pipes.length > 22) {
    return 300;
  }
  if (pipes.length > 10) {
    return 200;
  }
  if (pipes.length > 5) {
    return 150;
  }

  return 100;
}

export default (state = initialState, { type } = {}) => {
  let topHeight;

  switch (type) {
    case "RUNNING":
      return { ...state, x: state.x - 10 };
    case "GENERATE":
      const minimum = Math.round(window.innerHeight / 10);

      if (state.pipes.length === 0) {
        // First pipe - show it in the middle
        topHeight = Math.round(window.innerHeight / 2) - minimum;
      } else {
        // Get previous pipe height
        const prevHeight = state.pipes[state.pipes.length - 1].topHeight;

        const rand = Math.random();

        const maxDifference = determineMaximumDifference(state.pipes);
        // Limit new height to ±300px from previous height
        const minHeight = Math.max(minimum, prevHeight - maxDifference);
        const maxHeight = Math.min(window.innerHeight - minimum, prevHeight + maxDifference);
        topHeight = Math.round(minHeight + (rand * (maxHeight - minHeight)));
      }

      return { ...state, pipes: [...state.pipes, { topHeight }] };
    case "GAME_OVER":
      return initialState;
    default:
      return state;
  }
};
